<div class="overview-header">
  <mp-table-items-info [infoTitle]="overviewTitle()" [totalItems]="totalItems()" />

  <ng-content select="[tab-overview-header-context]" />
</div>

<mat-card class="overview-content-card">
  <ng-content />
</mat-card>
